var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"120","height":"120","rx":"60","fill":"#EDEAE2","key":0}),React.createElement("path",{"d":"M71 60L54.5 48.7417L54.5 71.2583L71 60Z","fill":"#141414","key":1})]);
}

PlayIcon.defaultProps = {"width":"120","height":"120","viewBox":"0 0 120 120","fill":"none"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
